import { ModalContentToggler } from '@components'

import { ModalProps } from '@billy/design-system'
import { useMemo } from 'react'

import { useCsvAccountCreationForm } from '@features/bankAccounts/elements/EditManualBankAccountModal/hooks/useCsvAccountCreationForm'
import { getBillReconciliationModalStates } from '@views/bills/elements/BillReconciliationModal/constants/billReconciliationModalStates'
import { getPaymentRegistrationModalView } from '@views/bills/utils/getPaymentRegistrationModalView'
import { getInvoiceReconciliationModalStates } from '@views/invoices/elements/InvoiceReconclliationModal/constants/invoiceReconciliationModalStates'

import { Scope } from '../../../../enums/scope'
import { isAuthorized } from '../../../../utils/isAuthorized'
import { BillType } from '../../../bills/enums/billType'
import { useContactBalance, useMultiplePayableSubjects } from '../../../paymentReconciliationModal/contexts'
import { useSubjectReconciliationSuggestions } from '../../../paymentReconciliationModal/hooks'
import { PayableSubject } from '../../../paymentReconciliationModal/types'

export interface SubjectReconciliationModalInnerProps extends ModalProps {
  subject: PayableSubject
}

export const SubjectReconciliationModalInner = ({ subject, ...modalProps }: SubjectReconciliationModalInnerProps) => {
  const { canUsePrepayment } = useContactBalance()
  const { isCreditNoteSelected } = useMultiplePayableSubjects()
  const { subjectHasMatchSuggestion } = useSubjectReconciliationSuggestions(subject)
  const csvAccountForm = useCsvAccountCreationForm(modalProps.id)
  const isAutoMatchAuthorized = isAuthorized(Scope.BankReconciliationAutoMatch)

  const initialState = useMemo(() => {
    return getPaymentRegistrationModalView(
      canUsePrepayment,
      isAutoMatchAuthorized && subjectHasMatchSuggestion,
      isCreditNoteSelected,
    )
  }, [canUsePrepayment, isAutoMatchAuthorized, subjectHasMatchSuggestion, isCreditNoteSelected])

  const states =
    subject.type === BillType.Bill
      ? getBillReconciliationModalStates(csvAccountForm)
      : getInvoiceReconciliationModalStates(csvAccountForm)

  return <ModalContentToggler initialState={initialState} states={states} {...modalProps} />
}
